import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { SafetyCertificateOutlined } from '@ant-design/icons';
import AccessGroups from "./index";
import ViewAccessGroup from "./view";
import EditAccessGroup from "./edit";
import accessRightsRoutes from "./access-group-users/routes"
import { MODULE_ACCESS_GROUPS } from "variables/constants";

const accessGroupsRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Access Groups",
		basePath: "access-groups",
		mainComponent: <AccessGroups />,
	    layout: "/console",	   
	    icon: <SafetyCertificateOutlined className="h-6 w-6" />,
	    subTitle:"Access Groups",
	    viewComponent: <ViewAccessGroup />,
	    createComponent: <EditAccessGroup />,
	    editComponent: <EditAccessGroup />,
		level: 2,
		moduleId: MODULE_ACCESS_GROUPS,
		chilModules: [
			...accessRightsRoutes,
		]
	})
]

export default accessGroupsRoutes;